function u(e){let n=[e],t=n.length;function r(){return e=n[t-1],e}return{push:o=>(n.length=t,n[t++]=typeof o=="function"?o(e):o,r()),undo:()=>(t>1&&(t-=1),r()),redo:()=>(t<n.length&&(t+=1),r())}}export{u as default};
